module.exports = __webpack_public_path__ + "img/video_carousel_background.aac737e8.jpg";